import React, { useState } from 'react';
import { MPPageTitle } from '../../../../components/ui';
import General from './components/StockGeneral/General';
import StockShortages from './components/StockShortage/StockShortages';
import Mermas from './components/Mermas/Mermas';
import { LocalSession } from 'types/LocalSession';

interface StockProps {
  lastSession: LocalSession | null;
}

const VIEWS = [
  { key: 'general' as const, label: 'Listado', subtitle: 'General' },
  { key: 'stockShortages' as const, label: 'Quiebres de Stock', subtitle: 'Quiebres de Stock' },
  { key: 'mermas' as const, label: 'Mermas', subtitle: 'Mermas' },
];

const Stock: React.FC<StockProps> = ({ lastSession }) => {
  const [currentView, setCurrentView] = useState<'general' | 'stockShortages' | 'mermas'>('general');

  const currentSubtitle = VIEWS.find(v => v.key === currentView)?.subtitle ?? '';

  return (
    <div className="flex flex-col gap-4 p-3 pb-6 lg:gap-5 lg:p-4 lg:pb-8">
      <MPPageTitle subtitle={currentSubtitle}>Stock</MPPageTitle>

      <div className="flex justify-center">
        <div className="mp-tab-group">
          {VIEWS.map(view => (
            <button
              key={view.key}
              className={`mp-tab ${currentView === view.key ? 'mp-tab-active' : ''}`}
              onClick={() => setCurrentView(view.key)}
            >
              {view.label}
            </button>
          ))}
        </div>
      </div>

      {currentView === 'general' && (
        <General lastSession={lastSession} />
      )}
      {currentView === 'stockShortages' && (
        <StockShortages />
      )}
      {currentView === 'mermas' && (
        <Mermas />
      )}
    </div>
  );
};

export default Stock;